import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cscProductImageGrid = {
  gap: css`var(--csc-product-image-grid-gap, ${csSpacing.spacing04})`,
  aspect: css`var(--csc-product-image-grid-aspect-ratio, 1 / 1)`,
  pairAspect: css`var(--csc-product-image-grid-pair-aspect-ratio, 4 / 5)`,
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  csc-lightbox {
    --csc-lightbox-main-image-aspect-ratio: ${cscProductImageGrid.aspect};
  }

  .csc-product-image-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${cscProductImageGrid.gap};
  }

  .tile {
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }

  .tile.full {
    grid-column: 1 / -1;
    aspect-ratio: ${cscProductImageGrid.aspect};
  }

  .tile:not(.full) {
    aspect-ratio: ${cscProductImageGrid.pairAspect};
  }

  .tile csc-lightbox-media {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    inset: 0;
  }

  .badge-group {
    position: absolute;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
  }

  .badge-group.position-top-left {
    top: ${csSpacing.spacing05};
    left: ${csSpacing.spacing05};
  }

  .badge-group.position-top-right {
    top: ${csSpacing.spacing05};
    right: ${csSpacing.spacing05};
    align-items: flex-end;
  }

  .badge-group.position-bottom-left {
    bottom: ${csSpacing.spacing05};
    left: ${csSpacing.spacing05};
  }

  .badge-group.position-bottom-right {
    bottom: ${csSpacing.spacing05};
    right: ${csSpacing.spacing05};
    align-items: flex-end;
  }
`
